"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetUserItemsDTO = exports.EquipItemDTO = exports.GetItemByCharacterIdDTO = exports.GetItemByIdDTO = exports.ItemListDTO = exports.GradesDefinitionDTO = exports.itemReferenceMatch = exports.ItemReference = exports.ServerItemDTO = void 0;
const class_validator_1 = require("class-validator");
class ServerItemDTO {
}
exports.ServerItemDTO = ServerItemDTO;
class ItemReference {
}
exports.ItemReference = ItemReference;
function itemReferenceMatch(itemReference, name, grade) {
    return itemReference.name === name && itemReference.grade === grade;
}
exports.itemReferenceMatch = itemReferenceMatch;
class GradesDefinitionDTO {
}
exports.GradesDefinitionDTO = GradesDefinitionDTO;
class ItemListDTO {
}
exports.ItemListDTO = ItemListDTO;
let GetItemByIdDTO = (() => {
    class GetItemByIdDTO {
    }
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], GetItemByIdDTO.prototype, "itemId", void 0);
    return GetItemByIdDTO;
})();
exports.GetItemByIdDTO = GetItemByIdDTO;
let GetItemByCharacterIdDTO = (() => {
    class GetItemByCharacterIdDTO {
    }
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], GetItemByCharacterIdDTO.prototype, "characterId", void 0);
    return GetItemByCharacterIdDTO;
})();
exports.GetItemByCharacterIdDTO = GetItemByCharacterIdDTO;
let EquipItemDTO = (() => {
    class EquipItemDTO {
    }
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], EquipItemDTO.prototype, "itemId", void 0);
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], EquipItemDTO.prototype, "userId", void 0);
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], EquipItemDTO.prototype, "characterId", void 0);
    return EquipItemDTO;
})();
exports.EquipItemDTO = EquipItemDTO;
let GetUserItemsDTO = (() => {
    class GetUserItemsDTO {
    }
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], GetUserItemsDTO.prototype, "userId", void 0);
    return GetUserItemsDTO;
})();
exports.GetUserItemsDTO = GetUserItemsDTO;
//# sourceMappingURL=Item.js.map